import { useState } from 'react';
import {
  Modal,
  Typography,
  Form,
  Input,
  Row,
  Col,
  notification,
  Button,
  Popconfirm,
} from 'antd';

import MESSAGES from '../../enums/Messages';

import { getCategories, postTemplateType } from '../../api/module/templates';
import { CustomSelector } from '../../components';
import { catchExceptionSRate } from '../../utils/helpers/helpers';

const { Title } = Typography;
const validateMessages = {
  required: 'El campo ${label} es requerido!',
};

const LoadTemplateProcessForm = ({
  isModalNewOpen,
  setIsModalNewOpen,
  person_type_id,
  contract_type_id,
  onRefresh,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (data) => {
    try {
      setLoading(true);

      const formData = { ...data };
      if (person_type_id === 2) formData.codigo = data.codigo + 'PJ';
      formData.etapa_contratacion = 2;
      formData.tipo_contrato = contract_type_id;
      formData.tipo_persona = person_type_id;

      await postTemplateType(formData);

      setIsModalNewOpen(false);
      setLoading(false);
      await onRefresh();
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_SUCCESS_MSG,
        duration: 2,
      });
    } catch (err) {
      setLoading(false);
      catchExceptionSRate(err, MESSAGES.DESC_ERROR_POST_MSG);
    }
  };

  return (
    <>
      <Modal
        title={
          <Title level={4} style={{ marginBottom: 0 }}>
            Crear plantilla
          </Title>
        }
        open={isModalNewOpen}
        closable={false}
        maskClosable={false}
        footer={[
          <Button
            key="back"
            onClick={() => setIsModalNewOpen(false)}
            disabled={loading}
          >
            Cancelar
          </Button>,
          <Popconfirm
            title="¿Está seguro(a) de la información registrada para esta nueva plantilla?"
            okText="Si"
            cancelText="No"
            onConfirm={() => {
              form.submit();
            }}
          >
            <Button
              key="submit"
              type="primary"
              htmlType="button"
              loading={loading}
              disabled={loading}
            >
              Crear
            </Button>
          </Popconfirm>,
        ]}
        width={800}
        destroyOnClose
      >
        <Form
          form={form}
          layout="vertical"
          name="basic"
          validateMessages={validateMessages}
          onFinish={onFinish}
        >
          <Row gutter={12}>
            <Col span={8}>
              <Form.Item
                label="Código"
                name="codigo"
                rules={[{ required: true, message: 'es requerido' }]}
              >
                <Input
                  placeholder="Código..."
                  allowClear
                  suffix={person_type_id === 2 ? 'PJ' : ''}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Nombre"
                name="nombre"
                rules={[{ required: true, message: 'es requerido' }]}
              >
                <Input placeholder="Nombre..." allowClear />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Sigla"
                name="sigla"
                rules={[{ required: true, message: 'es requerido' }]}
              >
                <Input placeholder="Sigla..." allowClear />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Seleccione la categoría"
                name="categoria"
                rules={[{ required: true, message: 'es requerido' }]}
              >
                <CustomSelector
                  selectorProps={{
                    style: { width: '100%' },
                    placeholder: 'Seleccione la categoría... ',
                  }}
                  endpointFetch={async () => {
                    return await getCategories();
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default LoadTemplateProcessForm;
